import { Component } from '@angular/core';
import { PoUploadFile, PoBreadcrumb } from '@po-ui/ng-components';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-carga-inicial',
  templateUrl: './carga-inicial.component.html',
  styleUrls: ['./carga-inicial.component.css'],
  standalone: false,
})
export class CargaInicialImportacoesComponent {
  rotas = [
    { tabela: '[JC8301]', url: environment.apiUrl + '/v1/carga-inicial/produtos' },
    { tabela: '[JC8302]', url: environment.apiUrl + '/v1/carga-inicial/participantes' },
    { tabela: '[JC8303]', url: environment.apiUrl + '/v1/carga-inicial/cfop' },
    { tabela: '[JC8305]', url: environment.apiUrl + '/v1/carga-inicial/inventario' },
    { tabela: '[JC8306]', url: environment.apiUrl + '/v1/carga-inicial/nfe' },
    { tabela: '[JC8310]', url: environment.apiUrl + '/v1/carga-inicial/enquadramento-legal' },
    {
      tabela: '[JC8312]',
      url: environment.apiUrl + '/v1/carga-inicial/codigos-internos',
    },
    {
      tabela: '[MASCARA]',
      url: environment.apiUrl + '/v1/carga-inicial/mascara',
    },
  ]

  readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'CAT 83/2009' },
      { label: 'Carga de Dados' },
      { label: 'Carga Inicial' }
    ]
  };
}
